import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "orderDetailTransport"
  }, [_c("a-table", {
    attrs: {
      rowKey: "id",
      columns: _vm.Columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.transportList,
      pagination: false
    },
    scopedSlots: _vm._u([{
      key: "expressStatus",
      fn: function fn(text, record) {
        return _c("span", {}, [record.queryWay == 1 ? [_vm._v(" " + _vm._s(_vm.getExpressStatus(record.expressStatus)) + " ")] : _vm._e(), record.queryWay == 2 ? [_c("a", {
          attrs: {
            href: record.queryUrl + record.expressNo,
            target: "_blank"
          }
        }, [_vm._v(_vm._s(_vm.$t("orderDetail.transportInfo.look")))])] : _vm._e(), record.queryWay == 3 ? [_vm._v(" " + _vm._s(_vm.$t("orderDetailTransport.noModeOfTransport2")) + " ")] : _vm._e()], 2);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-popconfirm", {
          attrs: {
            placement: "topRight",
            title: _vm.$t("public.deletePromp"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.deleteTransport(record.id);
            }
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("public.delete")))])])], 1);
      }
    }])
  }), _c("a-modal", {
    attrs: {
      title: _vm.$t("orderDetailTransport.addOrderNoTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      ok: _vm.addHandle
    },
    model: {
      value: _vm.addVisible,
      callback: function callback($$v) {
        _vm.addVisible = $$v;
      },
      expression: "addVisible"
    }
  }, [_c("a-form-model", {
    ref: "addRuleForm",
    attrs: {
      rules: _vm.addRules,
      model: _vm.addModalValue
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderDetailTransport.transportationName"),
      prop: "transportationId"
    }
  }, [_c("a-select", {
    model: {
      value: _vm.addModalValue.transportationId,
      callback: function callback($$v) {
        _vm.$set(_vm.addModalValue, "transportationId", $$v);
      },
      expression: "addModalValue.transportationId"
    }
  }, _vm._l(_vm.TransportationList, function (item, key) {
    return _c("a-select-option", {
      key: key,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.showName))]);
  }), 1)], 1), _vm.transportNameList.isOldOrder == 0 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderDetailTransport.modeOfTransport"),
      prop: "transportId"
    }
  }, [_c("a-select", {
    model: {
      value: _vm.addModalValue.transportId,
      callback: function callback($$v) {
        _vm.$set(_vm.addModalValue, "transportId", $$v);
      },
      expression: "addModalValue.transportId"
    }
  }, _vm._l(_vm.transportNameList.transportList, function (item, key) {
    return _c("a-select-option", {
      key: key,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderDetailTransport.expressNo")
    }
  }, [_c("a-input", {
    model: {
      value: _vm.addModalValue.expressNo,
      callback: function callback($$v) {
        _vm.$set(_vm.addModalValue, "expressNo", $$v);
      },
      expression: "addModalValue.expressNo"
    }
  })], 1)], 1)], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("orderDetailTransport.expressDetail"),
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.detailVisible,
      callback: function callback($$v) {
        _vm.detailVisible = $$v;
      },
      expression: "detailVisible"
    }
  }, [_c("a-table", {
    attrs: {
      rowKey: "id",
      columns: _vm.detailColumns,
      loading: _vm.isTableLoading,
      "data-source": _vm.transportDetailList
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };